import script from "./MonitoringPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoringPanel.vue?vue&type=script&setup=true&lang=js"

import "./MonitoringPanel.vue?vue&type=style&index=0&id=b4de87ec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4de87ec"]])

export default __exports__